import { VehicleActionMenu } from "./VehicleActionMenu";
import { formatMac } from "src/utils/macAddress";

export const vehicleListColumns = (isReadOnly) => [
  ...(!isReadOnly
    ? [
        {
          field: "actions",
          headerName: "",
          type: "actions",
          width: 50,
          getActions: (params) => [
            <VehicleActionMenu id={params.id} row={params.row} />,
          ],
        },
      ]
    : []),
  {
    field: "registration_number",
    headerName: "License Plate",
    flex: 1,
    minWidth: 150,
  },
  {
    // Both battery MACs (sessions are matched to the vehicle by these).
    field: "battery_mac_1",
    headerName: "Battery MACs",
    flex: 1.4,
    minWidth: 190,
    sortable: false,
    renderCell: ({ row }) => {
      const macs = [row.battery_mac_1, row.battery_mac_2].filter(Boolean).map(formatMac);
      return macs.length ? (
        <span style={{ lineHeight: 1.4, whiteSpace: "normal" }}>{macs.join(", ")}</span>
      ) : (
        <span style={{ color: "#999" }}>—</span>
      );
    },
  },
  {
    field: "vin",
    headerName: "VIN",
    flex: 1,
    minWidth: 150,
  },
  {
    field: "make",
    headerName: "Make",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "model",
    headerName: "Model",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "vehicle_type",
    headerName: "Type",
    flex: 1,
    minWidth: 100,
  },
];
